import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import get from 'lodash/get'

const isDirectSupplierPath = "forms.kadBranches.isDirectSupplier"
const isIndirectSupplierPath = "forms.kadBranches.isIndirectSupplier"
const isEquipmentVoucherPath = "forms.kadBranches.isEquipmentVoucher"
const isServiceVoucherPath = "forms.kadBranches.isServiceVoucher"

export function useSupplierType() {
  const isDirectSupplier = useSelector(state => get(state, isDirectSupplierPath))
  const isIndirectSupplier = useSelector(state => get(state, isIndirectSupplierPath))
  const isEquipmentVoucher = useSelector(state => get(state, isEquipmentVoucherPath))
  const isServiceVoucher = useSelector(state => get(state, isServiceVoucherPath))

  return useMemo(() => ({
    isDirectSupplier,
    isIndirectSupplier,
    isEquipmentVoucher,
    isServiceVoucher
  }), [isDirectSupplier, isEquipmentVoucher, isIndirectSupplier, isServiceVoucher])
}
